module.exports = __webpack_public_path__ + "img/education_add.b3900cd1.svg";